<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      loading: false,
      uploading: false,

      selectedFile: null,
      fileError: "",
      isDragging: false,

      list: null,

      fields: [
        { key: "date_added",  label: "Data",      sortable: false },
        { key: "filename",    label: "Arquivo",   sortable: false },
        { key: "total",       label: "Total",     sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "total_valid", label: "Válidos",   sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "total_sent",  label: "Enviados",  sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "status",      label: "Status",    sortable: false, tdClass: "text-center", thClass: "text-center" },
        { key: "actions",     label: "Ações",     sortable: false, tdClass: "text-center", thClass: "text-center" },
      ],

      currentPage: 1,
      perPage: 25,

      deletingId: null,
    };
  },
  computed: {
    totalRows() {
      return this.list ? this.list.length : 0;
    },
    paginatedList() {
      if (!this.list) return [];
      const start = (this.currentPage - 1) * this.perPage;
      return this.list.slice(start, start + this.perPage);
    },
  },
  methods: {
    getImports() {
      this.loading = true;
      this.list = null;

      api
        .get("exclusaoindividual/imports")
        .then((response) => {
          if (response.data.status === "success") {
            this.list = response.data.list;
            this.currentPage = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onDrop(e) {
      this.isDragging = false;
      const file = e.dataTransfer.files[0];
      if (!file) return;
      this.validateAndSetFile(file);
    },

    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.validateAndSetFile(file);
    },

    validateAndSetFile(file) {
      this.fileError = "";
      const allowed = ["xlsx", "xls"];
      const ext = file.name.split(".").pop().toLowerCase();
      if (!allowed.includes(ext)) {
        this.fileError = "Formato inválido. Envie um arquivo .xlsx ou .xls.";
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    },

    uploadFile() {
      if (!this.selectedFile) {
        this.fileError = "Selecione um arquivo antes de importar.";
        return;
      }

      this.uploading = true;
      this.fileError = "";

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      api
        .post("exclusaoindividual/imports/upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.$bvModal.hide("modal-upload");
            this.$router.push("/exclusaoindividual/importacoes/" + response.data.id);
          } else {
            this.fileError = response.data.message;
          }
        })
        .finally(() => {
          this.uploading = false;
        });
    },

    openUploadModal() {
      this.selectedFile = null;
      this.fileError    = "";
      this.isDragging   = false;
      this.$nextTick(() => {
        this.$bvModal.show("modal-upload");
      });
    },

    confirmDelete(id) {
      this.deletingId = id;
      this.$bvModal.show("modal-delete");
    },

    deleteImport() {
      api
        .post("exclusaoindividual/imports/delete", { id_import: this.deletingId })
        .then((response) => {
          if (response.data.status === "success") {
            this.$bvModal.hide("modal-delete");
            this.getImports();
          }
        });
    },

    statusLabel(status) {
      const map = {
        pending: "Pendente",
        sent:    "Enviado",
        deleted: "Excluído",
      };
      return map[status] || status;
    },

    statusVariant(status) {
      const map = {
        pending: "warning",
        sent:    "success",
        deleted: "danger",
      };
      return map[status] || "secondary";
    },
  },
  mounted() {
    this.getImports();
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">
        <router-link tag="a" to="/exclusaoindividual">Exclusão Individual</router-link>
      </li>
      <li class="breadcrumb-item active">Importações</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Importações</h3>
        <p></p>
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="py-2">
            ações
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-item v-on:click="openUploadModal();">Nova Importação</b-dropdown-item>
      </b-dropdown>
    </div>

    <!-- Tabela -->
    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <b-spinner variant="default"></b-spinner>
        </div>

        <div v-else-if="list && list.length === 0" class="text-center py-5 text-muted">
          Nenhuma importação encontrada.
        </div>

        <div v-else-if="list">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-muted small">{{ totalRows }} registro(s)</span>
            <b-form-select
              v-model="perPage"
              :options="[10, 25, 50, 100]"
              size="sm"
              style="width: auto;"
            ></b-form-select>
          </div>

          <div class="table-responsive">
            <b-table
              :items="paginatedList"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="Nenhum registro encontrado."
            >
              <template #cell(status)="data">
                <b-badge :variant="statusVariant(data.item.status)">
                  {{ statusLabel(data.item.status) }}
                </b-badge>
              </template>

              <template #cell(actions)="data">
                <router-link
                  :to="'/exclusaoindividual/importacoes/' + data.item.id"
                  class="btn btn-sm btn-outline-secondary mr-1"
                >
                  <i class="bx bx-show"></i>
                </router-link>
                <b-button
                  v-if="data.item.status !== 'sent'"
                  size="sm"
                  variant="outline-danger"
                  @click="confirmDelete(data.item.id)"
                >
                  <i class="bx bx-trash"></i>
                </b-button>
              </template>
            </b-table>
          </div>

          <div class="d-flex justify-content-center mt-3" v-if="totalRows > perPage">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Upload -->
    <b-modal id="modal-upload" title="Nova Importação" modal-class="modal-right" hide-footer>
      <p class="mb-3">
        Envie uma planilha <strong>.xlsx</strong> ou <strong>.xls</strong> com até <strong>500 registros</strong>.
      </p>
      <div class="font-size-13 mb-3 p-3 bg-light rounded border">
        <div class="font-weight-semibold mb-2">Dados a partir da <strong>linha 2</strong> da planilha (a linha 1 pode ser título)</div>
        <ul class="mb-0 pl-3">
          <li><strong>A</strong>: Nome / Razão Social</li>
          <li><strong>B</strong>: CPF ou CNPJ</li>
          <li><strong>C</strong>: Nome do sócio (obrigatório para CNPJ)</li>
          <li><strong>D</strong>: CPF do sócio (obrigatório para CNPJ)</li>
          <li><strong>E</strong>: Email <span class="text-muted">(opcional)</span></li>
          <li><strong>F</strong>: Celular / WhatsApp <span class="text-muted">(opcional)</span></li>
        </ul>
        <p class="mb-0 mt-2 text-muted font-size-12">
          Recomenda-se formatar as colunas <strong>B</strong> e <strong>D</strong> como <strong>Texto</strong> no Excel para não perder zeros à esquerda.
          O sistema também tenta completar CPF com 11 dígitos e CNPJ com 14 (zeros à esquerda) quando o arquivo envia o número sem todos os dígitos.
        </p>
      </div>

      <div
        class="rounded p-4"
        :style="{
          border: selectedFile ? '2px solid #34C392' : (isDragging ? '2px solid #0F3396' : '2px dashed #d1d1e3'),
          backgroundColor: selectedFile ? '#f0fdf8' : (isDragging ? '#eef1fd' : 'transparent'),
          cursor: selectedFile ? 'default' : 'pointer',
          transition: 'all .2s',
          minHeight: '120px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: selectedFile ? 'flex-start' : 'center',
        }"
        @click="!selectedFile && $refs.fileInput.click()"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="onDrop"
      >
        <input ref="fileInput" type="file" accept=".xlsx,.xls" class="d-none" @change="onFileChange" />

        <div v-if="!selectedFile" class="w-100 text-center">
          <i class="bx bx-cloud-upload font-size-24 text-muted mb-2 d-block"></i>
          <p class="mb-1 font-weight-semibold font-size-14">Arraste o arquivo aqui ou clique para selecionar</p>
          <p class="font-size-12 text-muted mb-0">.xlsx ou .xls · máximo 500 registros</p>
        </div>

        <div v-else class="w-100 d-flex align-items-center" style="min-width: 0;" @click.stop>
          <i class="bx bx-file text-success font-size-22 mr-2 flex-shrink-0"></i>
          <span
            class="font-size-13 font-weight-semibold text-truncate flex-fill"
            style="min-width: 0;"
            :title="selectedFile.name"
          >{{ selectedFile.name }}</span>
          <button
            type="button"
            class="btn btn-sm btn-soft-danger ml-3 flex-shrink-0 d-inline-flex align-items-center"
            @click.stop="selectedFile = null; fileError = ''; $refs.fileInput.value = ''"
          >
            <i class="bx bx-trash mr-1"></i> Remover
          </button>
        </div>
      </div>

      <div v-if="fileError" class="text-danger small mt-2">
        <i class="bx bx-error-circle mr-1"></i>{{ fileError }}
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="default" size="lg" class="btn-block" :disabled="uploading || !selectedFile" @click="uploadFile">
          <b-spinner v-if="uploading" small class="mr-1"></b-spinner>
          {{ uploading ? 'Processando...' : 'Importar' }}
        </b-button>
      </div>
    </b-modal>

    <!-- Modal Confirmar Exclusão -->
    <b-modal id="modal-delete" title="Excluir Importação" centered hide-footer>
      <p>Tem certeza que deseja excluir esta importação?</p>
      <div class="d-flex justify-content-end mt-3">
        <b-button variant="outline-secondary" size="sm" class="mr-2" @click="$bvModal.hide('modal-delete')">
          Cancelar
        </b-button>
        <b-button variant="danger" size="sm" @click="deleteImport">
          Excluir
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>

